export default __webpack_public_path__ + "static/media/backimage2.51b57050.png";